import { measureImages } from '@/assets/images/measures'
import type { RetrofitName } from '@/shared/types'

/**
 * Get the image for a specific retrofit measure
 * @param retrofit - The retrofit type
 * @returns The image source for the measure
 */
export const getMeasureImage = (retrofit: RetrofitName): string => {
  return measureImages[retrofit]
}
